import styled from '@emotion/styled';
import { BREAKPOINTS, mediaQuery } from '@presentation/styles';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 24px;

  > div {
    width: 50%;
  }

  ${mediaQuery(BREAKPOINTS.tablet)} {
    flex-direction: column;

    > div {
      width: 100%;
    }
  }
`;

export const Button = styled.div`
  margin-top: 40px;
`;

export const Image = styled.div`
  max-width: 400px;

  ${mediaQuery(BREAKPOINTS.tablet)} {
    display: none;
  }
`;
